module.exports = __webpack_public_path__ + "static/media/user-profile.e49bb8b3.svg";